import { Link } from 'react-router-dom';

export function WedgeFooter() {
  return (
    <footer className="border-t border-slate-200 bg-[#f7f2ea]">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-4 py-10 md:px-8 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-xl">
          <p className="text-xs font-black uppercase tracking-[0.28em] text-slate-500">
            Practical AI systems for revenue and workflow execution.
          </p>
          <p className="mt-4 text-sm leading-7 text-slate-700">
            Dopomogai helps teams decide what to install first, then implements governed systems
            that reduce manual drag and improve execution quality.
          </p>
        </div>
        <div className="flex flex-wrap gap-4 text-sm font-semibold text-slate-600">
          <Link to="/software-services" className="hover:text-slate-950">
            Software Services
          </Link>
          <Link to="/ai-revenue-audit" className="hover:text-slate-950">
            AI Revenue Audit
          </Link>
          <Link to="/privacy-policy" className="hover:text-slate-950">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="hover:text-slate-950">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default WedgeFooter;
